import React from 'react'
import App from 'next/app'
import {ThemeProvider} from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from '../theme';
import ReactPiwik from 'react-piwik';
import Router from 'next/router'
import {config as fontAwesomeConfig, library} from '@fortawesome/fontawesome-svg-core';
import {
    faCheck,
    faChessClockAlt,
    faEnvelope,
    faEuroSign,
    faHomeAlt,
    faPaperPlane,
    faPhoneOffice,
    faSpinner,
    faUmbrellaBeach,
    faUser,
    faUserHardHat
} from '@fortawesome/pro-regular-svg-icons';
import {createIntl, createIntlCache, RawIntlProvider} from 'react-intl';
import {faGithub, faLinkedin} from '@fortawesome/free-brands-svg-icons'
import '@fortawesome/fontawesome-svg-core/styles.css'
import * as Sentry from '@sentry/browser';

library.add(
    faLinkedin,
    faGithub,
    faHomeAlt,
    faUserHardHat,
    faPhoneOffice,
    faEnvelope,
    faUser,
    faPaperPlane,
    faSpinner,
    faCheck,
    faEuroSign,
    faChessClockAlt,
    faUmbrellaBeach,
);

fontAwesomeConfig.autoAddCss = false // Tell Font Awesome to skip adding the CSS automatically since it's being imported above

Sentry.init({
    dsn: 'https://c94a647d91744f72acdaa0da814c3790@sentry.molabs.de/13'
});

const piwik = new ReactPiwik({
    url: 'p.molabs.de',
    siteId: 4,
    trackErrors: true,
    jsFilename: 'matomo.js',
    phpFilename: 'matomo.php',
});

const handleRouteChange = () => {
    piwik.track(window.location);
};

const cache = createIntlCache();

Router.events.on('routeChangeComplete', handleRouteChange);

class MyApp extends App {
    componentDidMount() {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentNode.removeChild(jssStyles);
        }
    }

    render() {
        const { Component, pageProps, router } = this.props;
        const locale = router.locale ?? router.defaultLocale;
        const messages = require(`../locales/${locale}.json`)
        const intl = createIntl(
            {
                locale: locale,
                defaultLocale: router.defaultLocale,
                messages,
            },
            cache
        );

        return (
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <RawIntlProvider value={intl}>
                    <Component {...pageProps} />
                </RawIntlProvider>
            </ThemeProvider>
        )
    }
}

export default MyApp;
